import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './EditableText.css';
import Icon from '../Icon';
import {times} from 'react-icons-kit/fa/times';
const actionButton = {
  iconClass: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  callback: PropTypes.func.isRequired,
};

const PADDING = 10;
const MIN_HEIGHT = 50;

class EditableText extends Component {
  static propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    primaryAction: PropTypes.shape(actionButton),
    secondaryAction: PropTypes.shape(actionButton),
    placeholder: PropTypes.string,
  };
  static defaultProps = {
    className: '',
    defaultValue: '',
    primaryAction: null,
    secondaryAction: null,
    placeholder: '',
  };
  constructor(props) {
    super(props);
    this.actionHandled = false;

    this.state = {
      text: props.defaultValue || '',
      isEditing: false,
      height: MIN_HEIGHT,
    };
  }
  cancelEdit = () => {
    this.actionHandled = true;
    this.setState({text: this.props.defaultValue});
  };
  onActionButtonClick = callback => {
    this.actionHandled = true;
    callback(this.textArea.value);
  };
  onTextAreaBlur = () => {
    // Blurring the text field should fire the primary action only if no action button was clicked during the blur
    if (!this.actionHandled && this.props.primaryAction) {
      this.onActionButtonClick(this.props.primaryAction.callback);
    }

    this.actionHandled = false;

    this.setState({
      isEditing: false,
      height: MIN_HEIGHT,
    });
  };
  onTextAreaFocus = () => {
    this.setState({
      isEditing: true,
      height: (this.textArea.scrollHeight || MIN_HEIGHT) + PADDING,
    });
    this.textArea.select();
  };
  onTextAreaChange = ({target}) => {
    this.setState({
      text: target.value,
      height: (this.textArea.scrollHeight || MIN_HEIGHT) + PADDING,
    });
  };
  render() {
    const {text, isEditing, height} = this.state;
    const {className, placeholder, primaryAction, secondaryAction} = this.props;
    const containerStyles = classNames(styles.container, className, {
      [styles.isEditing]: isEditing,
    });

    return (
      <div className={containerStyles} style={{height}}>
        <textarea
          ref={el => (this.textArea = el)}
          className={styles.textArea}
          placeholder={placeholder}
          value={text}
          onFocus={this.onTextAreaFocus}
          onBlur={this.onTextAreaBlur}
          onChange={this.onTextAreaChange}
        />
        {isEditing && (
          <div className={styles.buttons} style={{top: height}}>
            {secondaryAction && (
              <button
                type="button"
                className={styles.button}
                title={secondaryAction.tooltip}
                onMouseDown={() => this.onActionButtonClick(secondaryAction.callback)}
              >
                <i className={secondaryAction.iconClass} />
              </button>
            )}
            {primaryAction && (
              <button
                type="button"
                className={styles.button}
                title={primaryAction.tooltip}
                onMouseDown={() => this.onActionButtonClick(primaryAction.callback)}
              >
                <i className={primaryAction.iconClass} />
              </button>
            )}
            <button
              type="button"
              className={classNames(styles.button, styles.cancelButton)}
              title="cancel edit"
              onMouseDown={this.cancelEdit}
            >
              <Icon icon={times} />
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default EditableText;
